"use strict";

exports.__esModule = true;
exports.canElementPathContainElement = canElementPathContainElement;
var _getElementsInPath = require("./getElementsInPath");
var _getWidget = require("./getWidget");
var _getRequiredContextsInElement = require("./getRequiredContextsInElement");
var _getSuppliedContextsInElementPath = require("./getSuppliedContextsInElementPath");
/**
 * Determine whether the element at the given path can contain
 * the given element.
 */
function canElementPathContainElement(widgets, root, path, candidate) {
  var elements = (0, _getElementsInPath.getElementsInPath)(root, path);
  if (elements.length === 0) {
    return false;
  }
  var element = elements[elements.length - 1];
  if (element.type === candidate.type) {
    return false;
  }
  var widget = (0, _getWidget.getWidget)(widgets, element.type);
  if (!widget) {
    console.warn("Widget can't be added because widget could not be found for type " + element.type);
    return false;
  }
  if (!widget.isParent) {
    console.warn("Widget is not a parent so can't contain elements. You may need to add isParent to the widget config", widget);
    return false;
  }
  var requiredContexts = (0, _getRequiredContextsInElement.getRequiredContextsInElement)(widgets, candidate);
  if (requiredContexts.length === 0) {
    return true;
  }
  var suppliedContexts = (0, _getSuppliedContextsInElementPath.getSuppliedContextsInElementPath)(widgets, root, path);
  return requiredContexts.every(function (item) {
    return suppliedContexts.includes(item);
  });
}